import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getManifestAddressList(params) {
  return request({
    url: URL.partner.manifestAddress,
    method: 'get',
    params
  })
}

export function saveManifestAddress(data) {
  return request({
    url: URL.partner.manifestAddress,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delManifestAddress(uuid) {
  return request({
    url: URL.partner.manifestAddress + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
